import React from 'react';
import { Plus, Search } from 'lucide-react';

interface ProductsPageHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
}

const ProductsPageHeader: React.FC<ProductsPageHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onCreateClick
}) => {
  return (
    <>
      <div className="sm:flex sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-black text-tinta leading-tight">
            Seus <span className="italic text-bordo">produtos</span>
          </h1>
          <p className="mt-2 text-sm text-tinta-soft">
            Gerencie os produtos antes de adicioná-los à sua roda de prêmios.
          </p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button
            onClick={onCreateClick}
            className="inline-flex items-center px-4 py-2.5 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark transition-colors"
          >
            <Plus className="mr-2 h-4 w-4" />
            Novo Produto
          </button>
        </div>
      </div>

      {/* Search Bar */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-tinta-soft" />
        </div>
        <input
          type="text"
          className="block w-full pl-10 pr-3 py-2.5 bg-white border border-tinta/15 rounded-lg text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors"
          placeholder="Buscar produtos..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </>
  );
};

export default ProductsPageHeader;
